import * as clipboard from 'clipboard-polyfill'

export function copyText(text: string | number) {
  clipboard.writeText(String(text)).then(
    () => {
      ElMessage.success('复制成功')
    },
    () => {
      ElMessage.error('复制失败，请手动复制文本')
    },
  )
}
